import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { IcoMoon } from "../../common";
// import { noUndefStrings } from "../../../helpers/tags";
import { getPropertyTitle } from "../../../helpers/general-helpers";
import { Divider } from "../";
// import Divider from "../Divider/Divider";
import styles from "./styles.less";

const Header = ({
  className,
  titles,
  propertyType,
  propertyName,
  isMobileView
}) => (
  <div
    className={cx(styles.header, className, {
      [styles.mobileView]: isMobileView
    })}
  >
    <div className={styles.mainTitle}>{titles.VacationDetails}</div>
    <Divider />
    <div
      className={cx(styles.propertyName, {
        [styles.longName]: propertyName && propertyName.length > 10
      })}
    >
      <div className={styles.type}>
        <IcoMoon name="house" />
        <div className={styles.title}>
          {getPropertyTitle(titles, propertyType)}:
        </div>
      </div>
      <div className={styles.name}>{propertyName}</div>
      {/* <div className={styles.name}>{noUndefStrings`${propertyName}`}</div> */}
    </div>
  </div>
);

Header.propTypes = {
  propertyName: PropTypes.string,
  propertyType: PropTypes.string,
  className: PropTypes.string,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Cart/Header/Header.js